module.exports = __webpack_public_path__ + "static/a-home-behind-the-lens-image-1-800x533-13f9babeee8f088168882eb86d96bbb9.jpg";